module.exports = __webpack_public_path__ + "img/Shop-in-shop application form_1.da06b7ea.jpg";